<template>
  <header class="header">
    <b-container class="mt-4">
      <b-row>
        <b-col cols="12" md="4">
          <b-img left id="logo" :src="require('../images/gunnebo-logo.png')" alt="Gunnebo Logo"></b-img>
        </b-col>
      </b-row>
      <b-row>
        <b-col role="navigation" class="p-0">
          <b-nav tabs align="right" id="navigation">
            <b-nav-item to="/" exact-active-class="active">Home</b-nav-item>
            <b-nav-item to="/calculator" exact-active-class="active">Calculator</b-nav-item>
            <b-nav-item to="/midgrab" exact-active-class="active">Midgrab</b-nav-item>
            <b-nav-item to="/grabiq" exact-active-class="active">GrabiQ</b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
.header {
  padding: 10px;
  background-color: #000000;
}

#logo {
  width: 80%;
}

#navigation {
  border-color: #1b1b1b;
}

#navigation a {
  background-color: #1b1b1b;
  border-bottom-width: 0;
  border-radius: 0;
  border-color: #1b1b1b;
  color: #ffffff;
  margin-right: 0.7rem;
  width: 7vw;
  text-align: center;
}

#navigation .active {
  border-color: #1b1b1b;
  background-color: #000000;
  color: #0492c6;
}

@media only screen and (max-width: 2040px) {
  #navigation a {
    width: 10vw;
  }
}

@media only screen and (max-width: 950px) {
  #navigation a {
    width: 12vw;
  }
}

@media only screen and (max-width: 812px) {
  #navigation a {
    width: 13vw;
    font-size: 0.7rem;
  }
}

@media only screen and (max-width: 768px) {
  #navigation a {
    width: 13vw;
    margin-top: 1rem;
  }
}

@media only screen and (max-width: 576px) {
  #logo {
    width: 100%;
  }

  #navigation a {
    width: 18vw;
    font-size: 0.55rem;
    margin-top: 5vw;
  }
}

@media only screen and (max-width: 334px) {
  #navigation a {
    width: 17vw;
    margin-top: 5vw;
    font-size: 0.4rem;
  }
}
</style>
